// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class TripleFeatureCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: true,
      slides: {
        origin: 'center',
        perView: 1.1,
        spacing: 10,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 2.2,
            spacing: 15,
          },
        },
        '(min-width: 1201px)': {
          disabled: true,
        },
      },
    })
  }
}

if (!customElements.get('triple-feature-carousel')) {
  customElements.define('triple-feature-carousel', TripleFeatureCarousel)
}
